import drag from './drag';
import alignment from './alignment';

import exporter from './export';

export default (grapesjs) => {
  grapesjs.plugins.add('plugin-sp-commands', function (editor) {
    drag(editor);

    alignment(editor);

    exporter(editor);
  });
}
